/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2018 ICEMEDX, Inc.
***********************************************/
import { Component, Input, OnInit } from '@angular/core';
import { Iceutility } from '../../services/iceutility';

@Component({
	selector: 'icebuttongroup',
	templateUrl: './icebuttongroup.component.html',
	styleUrls: ['./icebuttongroup.component.scss']
})
export class IcebuttongroupComponent implements OnInit {
	@Input() buttonSettings: any;
  public defaultActiveButton: string = "";

	constructor() { }

  ngOnInit() {
  }

  getActiveButton(): string {
    if (Iceutility.isdefined(this.buttonSettings.activeButton)) {
      this.defaultActiveButton = this.buttonSettings.activeButton.toLowerCase();
    }
    else {
      this.defaultActiveButton = "";
    }
    return this.defaultActiveButton;
  }

  getValue(button: any): string {
    if (button.value == null) button.value = button.text ? button.text.toLowerCase() : '';
    return button.value;
  }
}
